module.exports = __webpack_public_path__ + "images/2c0dbf3223766910b8626331dc404e50.jpg";